(function ($) {
  var $doc = $(document);
  var $win = $(window);

  // Lazy Load
  var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy-load",
  });
  function load_images() {
    lazyLoadInstance.update();
  }

  // Toggle Mobile Menu
  $("#mobileMenuToggle, .menu-close").on("click", function (e) {
    e.preventDefault();
    $("html").toggleClass("menu--open");
  });

  // Make all external links open in new tab
  $("a")
    .filter('[href^="http"], [href^="//"]')
    .not('[href*="' + window.location.host + '"]')
    .attr("rel", "noopener noreferrer")
    .attr("target", "_blank");

  // mailchimp form field focus
  $(".mc4wp-form-fields input")
    .focus(function () {
      $(this).closest(".mc4wp-form-fields p").addClass("is-focused");
    })
    .on("blur input", function () {
      if ($(this).val().length) {
        $(this).closest(".mc4wp-form-fields p").addClass("is-filled");
      } else {
        $(this).closest(".mc4wp-form-fields p").removeClass("is-filled");
      }
      $(this).closest(".mc4wp-form-fields p").removeClass("is-focused");
    });

  // Sidebar Menu
  $(".burger-icon__wrap, #site-menu .close-btn").on("click", function (e) {
    e.preventDefault();
    $("#page-wrapper").toggleClass("nav__sidebar--open");
  });

  $(".has-arrow").each(function () {
    $(this)
      .append(
        '<span class="arrow"><svg width="79" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 6.5h-1v2h1v-2Zm76.707 1.707a1 1 0 0 0 0-1.414L71.843.429a1 1 0 1 0-1.414 1.414L76.086 7.5l-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364ZM1.5 8.5h76v-2h-76v2Z" fill="#fff"/></svg></span>'
      )
      .addClass("btn-arrow");
  });

  $(".wpforms-submit, .mc4wp-form-fields button[type='submit']").each(function () {
    $(this)
      .append(
        '<span class="arrow"><svg width="79" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 6.5h-1v2h1v-2Zm76.707 1.707a1 1 0 0 0 0-1.414L71.843.429a1 1 0 1 0-1.414 1.414L76.086 7.5l-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364ZM1.5 8.5h76v-2h-76v2Z" fill="#000"/></svg></span>'
      )
      .addClass("btn-arrow");
  });

  $("main .wp-block-button__link").each(function () {
    $(this)
      .append(
        '<span class="arrow d-inline-block ps-3"><svg xmlns="http://www.w3.org/2000/svg" width="81" height="17" viewBox="0 0 81 17"><path fill="#000" fill-rule="nonzero" d="m65.869.388.871.49 12 6.75 1.55.872-1.55.872-12 6.75-.871.49-.98-1.743.87-.49L74.433 9.5H.5v-2h73.932L65.76 2.622l-.872-.49.98-1.744Z"/></svg></span>'
      )
      .addClass("btn-arrow");
  });

  $("footer .wp-block-button__link").each(function () {
    $(this)
      .append(
        '<span class="arrow d-inline-block ps-3"><svg width="127" height="15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.812 6.5h-1v2h1v-2Zm124.083 1.707a1 1 0 0 0 0-1.414L119.531.429a1 1 0 1 0-1.414 1.414l5.657 5.657-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364ZM1.812 8.5h123.376v-2H1.812v2Z" fill="#000"/></svg></span>'
      )
      .addClass("btn-arrow");
  });


  function margin_container_size() {
    var $container = $(".container");
    var $window_width = $win.width();
    var $container_width = $container.width();
    var $margin_size = $window_width - $container_width;
    var $margin_size = $margin_size / 2;
    //console.log($margin_size);
    var $containerLeft = $(".container-left");
    $containerLeft.css("marginLeft", $margin_size);
    var $containerRight = $(".container-right");
    $containerRight.css("marginRight", $margin_size);
  }

  var image_swiper = new Swiper(".image-swiper", {
    // Optional parameters
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    slidesPerView: 1,
    speed: 3000,
    spaceBetween: 10,
    wrapperClass: "swiper-wrapper",
    pagination: {
      el: ".image-swiper-pagination",
      clickable: true,
      renderBullet: function (index, customBullet) {
        return '<span class="' + customBullet + '">' + (index + 1) + "</span>";
      },
    },
    on: {
      slideChange: {
        load_images,
      },
      init: load_images,
    },
  });

  image_swiper.on("slideChange", function () {
    wowSlider = new WOW({
      boxClass: "in-view", // default
      animateClass: "animate__animated", // default
      offset: 0, // default
      mobile: true, // default
      live: true, // default
    });
    wowSlider.init();
  });

  $(function () {
    margin_container_size();
    render_svg_anims();
    check_if_in_view();
    makeSquare();
    makeRect();

    wow = new WOW({
      boxClass: "in-view", // default
      animateClass: "animate__animated", // default
      offset: 0, // default
      mobile: true, // default
      live: true, // default
    });
    wow.init();

    $win.on("resize", function () {
      margin_container_size();
      makeSquare();
      makeRect();
      check_if_in_view();
    });
  });

  window.addEventListener("scroll", function () {
    check_if_in_view();
  });

  function makeSquare() {
    var $squared = $(".d-block-square");
    jQuery.each($squared, function () {
      var $element = $(this);
      var elementWidth = $element.outerWidth();
      $element.css("height", elementWidth);
    });
  }

  function makeRect() {
    var $rect = $(".d-block-rect");
    jQuery.each($rect, function () {
      var $element = $(this);
      var elementWidth = $element.outerWidth() * 0.9;
      $element.css("height", elementWidth);
    });
  }

  function render_svg_anims() {
    $(".svg-anim").each(function () {
      var t = $(this);
      var elem = t[0];
      var anim = t.data("animation");
      if (!t.data("anim-instance")) {
        var instance = bodymovin.loadAnimation({
          container: elem,
          renderer: "svg",
          loop: false,
          autoplay: false,
          path: anim,
          rendererSettings: {
            scaleMode: "noScale",
            clearCanvas: false,
            progressiveLoad: false, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
            hideOnTransparent: false, //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
          },
        });
        t.data("anim-instance", instance);
      }
    });
  }

  var check_if_in_view = debounce(function () {
    var window_height = $win.height();
    var window_top_position = $win.scrollTop();
    var window_bottom_position = window_top_position + window_height;
    $("[data-scroll-view]").each(function () {
      var $element = jQuery(this);
      var element_height = $element.outerHeight();
      var element_top_position = $element.offset().top;
      var element_bottom_position = element_top_position + element_height;
      //check to see if this current container is within viewport
      if (
        element_bottom_position >= window_top_position &&
        element_top_position <= window_bottom_position
      ) {
        $element.addClass("in-view");
        $(".svg-anim.in-view").each(function () {
          $(this).data("anim-instance").play();
        });
      } else {
        if (!$element.data("only-once")) {
          $element.removeClass("in-view");
        }
      }
    });
  }, 100);

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // Scroll to Top Button
  var offset = 300;
  var speed = 500;
  var duration = 500;
  $(window).on("scroll", function () {
    var scrollTop = $(this).scrollTop();
    if (scrollTop < offset) {
      $(".topbutton").fadeOut(duration);
    } else {
      $(".topbutton").fadeIn(duration);
    }
  });
  $(".topbutton").on("click", function () {
    $("html, body").animate({ scrollTop: 0 }, speed);
    return false;
  });
})(jQuery);
